import { Box, Card, Divider, Icon, Typography } from "@drone-js/core";
import { Skeleton } from "apps/oneOnboarding/complete/Skeleton";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { BatchCallToAction } from "./BatchCallToAction";
import { BatchPropertyContent } from "./BatchPropertyContent";
import { FailedToPublishListings } from "./FailedToPublishListings";
import { useBatchCompletePageViewModel } from "./useBatchCompletePageViewModel";

export const BatchWhatsNext = () => {
    const {
        cmsData: {
            complete: {
                whatsNextText,
                letUsDoAFinalReviewText,
                weWillSendAnEmailText,
                optimizeYourListingText,
                syncYourCalendarsAndDetailsText,
            },
        },
    } = useStaticDataAtomValue();
    const { publishedListings, isLoading } = useBatchCompletePageViewModel();
    const hasPublishedListings = publishedListings !== null && publishedListings.length > 0;

    return (
        <Box mb="32" data-element-name="batch-whats-next" data-testid="batch-whats-next">
            <Typography variant="heading-l" mb="16" textColor="base.default" data-testid="batch-whats-next-title">
                {whatsNextText}
            </Typography>
            <FailedToPublishListings />
            {isLoading ? (
                <Card
                    type="non-interactive"
                    variant="outlined"
                    p="24"
                    data-element-name="what-next-section"
                    data-testid="batch-whats-next-loading"
                >
                    <Skeleton />
                </Card>
            ) : hasPublishedListings ? (
                <Card
                    type="non-interactive"
                    variant="outlined"
                    p="24"
                    data-element-name="what-next-section"
                    data-testid="batch-whats-next-card"
                >
                    <Box data-testid="batch-published-listings-container">
                        {publishedListings.map((listing, index) => (
                            <Box
                                key={`listing-${listing.id}`}
                                mb={index < publishedListings.length - 1 ? "16" : "0"}
                                data-testid={`batch-published-listing-${listing.id}`}
                            >
                                <BatchPropertyContent {...listing} isPublishing={listing.isPublishing} />
                            </Box>
                        ))}
                    </Box>
                    <Divider direction="horizontal" my="24" />
                    <Box display="flex" data-testid="batch-final-review-section">
                        <Icon id="line.symbol.doc-check" size="32" data-testid="batch-final-review-icon" />
                        <Box ms="16">
                            <Typography
                                variant="heading-default"
                                textColor="base.default"
                                data-testid="batch-final-review-title"
                            >
                                {letUsDoAFinalReviewText}
                            </Typography>
                            <Typography
                                variant="body-default"
                                textColor="base.subtle"
                                mt="8"
                                data-testid="batch-final-review-description"
                            >
                                {weWillSendAnEmailText}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" my="24" data-testid="batch-optimize-listing-section">
                        <Icon id="line.symbol.home-check" size="32" data-testid="batch-optimize-listing-icon" />
                        <Box ms="16">
                            <Typography
                                variant="heading-default"
                                textColor="base.default"
                                data-testid="batch-optimize-listing-title"
                            >
                                {optimizeYourListingText}
                            </Typography>
                            <Typography
                                variant="body-default"
                                textColor="base.subtle"
                                mt="8"
                                data-testid="batch-optimize-listing-description"
                            >
                                {syncYourCalendarsAndDetailsText}
                            </Typography>
                        </Box>
                    </Box>
                    <BatchCallToAction />
                </Card>
            ) : null}
        </Box>
    );
};
